import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/internal/operators";
import { map } from "rxjs/operators";
import { AppService } from "../../../core/services/app.service";
import { CacheService } from "../../../shared/services/cache.service";

@Injectable({
  providedIn: "root",
})
export class GroupService {
  groupApi = AppService.getApiUrl() + "/api/groups";
  groupUserApi = AppService.getApiUrl() + "/api/GroupUsers";
  needForceGetMyGroup = true;
  digitalMemoryApi = AppService.getApiUrl() + "/api/digitalMemoryLogs";

  constructor(public http: HttpClient, private cacheService: CacheService) {}

  createGroup(data) {
    return this.http.post(this.groupApi, data).pipe(
      tap((res: any) => {
        this.needForceGetMyGroup = true;
      })
    );
  }

  markAsPrimaryPhoto(data) {
    return this.http.post(this.groupUserApi + "/primaryLocationPhoto", data);
  }

  editGroup(data) {
    return this.http.put(this.groupApi + "/" + data.id, data).pipe(
      tap((res: any) => {
        this.needForceGetMyGroup = true;
      })
    );
  }

  deleteGroup(groupId) {
    return this.http.delete(this.groupApi + "/" + groupId).pipe(
      tap((res: any) => {
        this.needForceGetMyGroup = true;
      })
    );
  }

  addMemberToGroup(data) {
    return this.http.post(this.groupUserApi + "/addMember", data);
  }

  getGroup(groupId) {
    return this.http.get(
      this.groupApi +
        "/" +
        groupId +
        `?filter={"include": ["partner", {"travel_kit": ["recommendations", "wallpapers", {"courses": "courseChapters"}]}]}`
    );
  }

  accept(groupId) {
    return this.http
      .post(this.groupUserApi + "/accept", {
        groupId: groupId,
      })
      .pipe(
        tap((res: any) => {
          this.needForceGetMyGroup = true;
        })
      );
  }

  updateGroupMember(userGroup, level) {
    return this.http
      .post(this.groupUserApi + "/member", {
        groupId: userGroup.groupId,
        userId: userGroup.userId,
        level: level,
      })
      .pipe(
        tap((res: any) => {
          this.needForceGetMyGroup = true;
        })
      );
  }

  sendRequest(groupId) {
    return this.http
      .post(this.groupUserApi + "/requestToJoin", {
        groupId: groupId,
      })
      .pipe(
        tap((res: any) => {
          this.needForceGetMyGroup = true;
        })
      );
  }

  removeUserFromGroup(userGroupId) {
    return this.http.delete(this.groupUserApi + `/${userGroupId}`).pipe(
      tap((res: any) => {
        this.needForceGetMyGroup = true;
      })
    );
  }

  approve(userGroup) {
    return this.http
      .post(this.groupUserApi + `/acceptRequestJoinGroup`, {
        userId: userGroup.userId,
        groupId: userGroup.groupId,
      })
      .pipe(
        tap((res: any) => {
          this.needForceGetMyGroup = true;
        })
      );
  }

  getMemberList(groupId, skip = 0, limit = 10, options?, customerId?, status?) {
    let url =
      this.groupUserApi +
      `?filter[include]=customer&filter[include]=group` +
      `&filter[where][groupId]=${groupId}` +
      `&filter[skip]=${skip}&filter[limit]=${limit}&filter[order]=status desc`;

    if (customerId) {
      url = url + `&filter[where][userId]=${customerId}`;
    }

    if (status) {
      url = url + `&filter[where][status]=${status}`;
    }
    return this.http.get(url, options);
  }

  getGroupUser(groupId, userId) {
    return this.http.get(
      this.groupUserApi +
        `?filter[where][groupId]=${groupId}&filter[where][userId]=${userId}`
    );
  }

  getMyGroups(userId, status = null, force = false) {
    let queryParams = `?filter[include]=group&filter[where][userId]=${userId}`;

    if (status) {
      queryParams = queryParams + `&filter[where][status]=${status}`;
      if (status == "joined") {
        const request = this.cacheService.cacheRequest(
          "joined-group",
          this.http.get(this.groupUserApi + queryParams).pipe(
            tap((res: any) => {
              if (this.needForceGetMyGroup) {
                this.needForceGetMyGroup = false;
              }
            })
          ),
          this.needForceGetMyGroup
        );

        return request.getResult();
      }
    }

    return this.http.get(this.groupUserApi + queryParams);
  }
  getDigitalMemoryLog(userId, shipId = 1) {
    return this.http.get(this.groupUserApi);
  }

  createDigitalMemoryDraft(shipId) {
    return this.http.post(this.digitalMemoryApi + "/draft", { shipId: shipId });
  }

  searchGroup(keyword) {
    const queryObject = {
      where: {
        and: [{ name: { like: `%${keyword}%` } }, { subType: "public" }],
      },
      include: "ownerData",
      order: "name ASC",
      limit: 10,
    };

    const filter = encodeURIComponent(JSON.stringify(queryObject));
    const url = `${this.groupApi}?filter=${filter}`;

    return this.http.get(url).pipe(
      map((res: any) => {
        if (res.Data.length > 0) {
          Array.from(res.Data, (item: any) => {
            item.title = item.name + " - " + item.ownerData.fullName;
          });
        }
        return res.Data || [];
      })
    );
  }

  updateGroup(data) {
    return this.http.post(AppService.getApiUrl() + "/api/", data);
  }
}
